import React, {
  PropTypes as T,
  Component,
} from 'react';
import radium from 'radium';
import { Link as link } from 'react-router';

const Link = radium(link);

const styles = {
  wrapper: {
    width: 250,
    height: '100%',
    backgroundColor: '#5e5e5e',
    display: 'block',
    padding: '10px 0 0 0',
    '@media (max-width: 1024px)': {
      width: '100%',
      height: 66,
      lineHeight: '66px',
      padding: 0,
      backgroundColor: '#fed312',
      position: 'relative',
      zIndex: 99,
    }
  },
  link: {
    color: '#fff',
    fontSize: 18,
    width: 176,
    height: 66,
    borderBottom: '1px solid rgba(255, 255, 255, 0.5)',
    display: 'block',
    lineHeight: '66px',
    textDecoration: 'none',
    margin: '0 auto',
    padding: 0,
    textAlign: 'center',
    fontWeight: 100,
    cursor: 'pointer',
    ':hover': {
      color: '#fed312',
    },
    '@media (max-width: 1024px)': {
      color: '#004d9f',
      letterSpacing: 12,
      fontSize: 28,
      display: 'none',
      width: '100%',
    },
    '@media (max-width: 767px)': {
      fontSize: 20,
    }
  },
  actived: {
    color: '#fed312',
    '@media (max-width: 1024px)': {
      display: 'block',
    },
  },
  noBottomLine: {
    borderBottom: 0,
  },
  caret: {
    display: 'none',
    '@media (max-width: 1024px)': {
      display: 'block',
      position: 'absolute',
      right: 20,
      top: 10,
      fontSize: 40,
      color: '#004d9f',
      cursor: 'pointer',
    },
  },
  naviExtend: {
    '@media (max-width: 1024px)': {
      height: 500,
      position: 'absolute',
    },
  },
  shown: {
    '@media (max-width: 1024px)': {
      display: 'block',
    },
  },
};

class Sidebar extends Component {
  constructor(props) {
    super(props);

    this.drawing = true;

    this.state = {
      showNavi: false,
    };
  }

  caretClick() {
    this.setState({
      showNavi: !this.state.showNavi,
    });
  }

  render() {
    const {
      showNavi,
    } = this.state;

    const {
      group,
    } = this.props;

    return (
      <sidebar style={[styles.wrapper, showNavi && styles.naviExtend]} onClick={() => this.caretClick()}>
        <span className="fa fa-caret-down" style={styles.caret} />
        <Link
          to="/comparisons"
          key="comparisons"
          style={[styles.link, group === 'comparisons' && styles.actived, showNavi && styles.shown]}>單雙耳比較</Link>
        <Link
          to="/simulators"
          key="simulators"
          style={[styles.link, group === 'simulators' && styles.actived, showNavi && styles.shown]}>聽力模擬</Link>
        <Link
          to="/questions"
          key="questions"
          style={[styles.link, group === 'questions' && styles.actived, showNavi && styles.shown]}>為何需配戴助聽器</Link>
        <Link
          to="/ears"
          key="ears"
          style={[styles.link, group === 'ears' && styles.actived, showNavi && styles.shown]}>耳朵模擬圖</Link>
        <Link
          to="/specifications"
          key="specifications"
          style={[styles.link, group === 'specifications' && styles.actived, showNavi && styles.shown]}>功能比較</Link>
        <Link
          to="/earHair"
          key="earHair"
          style={[styles.link,
          group === 'earHair' && styles.actived,
          showNavi && styles.shown]}>耳毛細胞比較圖</Link>
        <Link
          to="/selections"
          key="selections"
          style={[styles.link,
                  styles.noBottomLine,
                  group === 'selections' && styles.actived, showNavi && styles.shown]}>選配室</Link>
      </sidebar>
    );
  }
}

Sidebar.propTypes = {
  group: T.string,
};

export default radium(Sidebar);



// WEBPACK FOOTER //
// ./components/Sidebar.js